var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2862 5.55435C16.6289 6.89085 16.6289 9.68085 16.6289 9.68085C16.6289 9.68085 16.6289 12.4708 16.2862 13.8073C16.0957 14.5461 15.5384 15.1273 14.8327 15.3238C13.5509 15.6808 9.12891 15.6808 9.12891 15.6808C9.12891 15.6808 4.70916 15.6808 3.42516 15.3238C2.71641 15.1243 2.15991 14.5438 1.97166 13.8073C1.62891 12.4708 1.62891 9.68085 1.62891 9.68085C1.62891 9.68085 1.62891 6.89085 1.97166 5.55435C2.16216 4.8156 2.71941 4.23435 3.42516 4.03785C4.70916 3.68085 9.12891 3.68085 9.12891 3.68085C9.12891 3.68085 13.5509 3.68085 14.8327 4.03785C15.5414 4.23735 16.0979 4.81785 16.2862 5.55435ZM7.62891 12.3058L12.1289 9.68085L7.62891 7.05585V12.3058Z",
    fill: "#9FDCE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.128906 0.680847)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.690faa5f93230c70ddef522d863f01fc.svg";
export { ForwardRef as ReactComponent };